import { EmptyAlert } from '@/shared/ui/EmptyAlert'

export const FeedEmptyState = () => (
  <EmptyAlert
    title="Nenhum post ainda"
    subtitle="Seja o primeiro a compartilhar algo com os participantes!"
  />
)
